import UserIdentificationPublicationModalComponent from "./UserIdentificationPublicationModalComponent";

export default UserIdentificationPublicationModalComponent;